import React from 'react';
import { Routes, Route } from "react-router-dom";
import AuthPage from "../../pages/AuthPage";
import OverviewPage from "../../pages/OverviewPage";
import ShipmentTrackingPage from "../../pages/ShipmentTrackingPage";
import CommunicatorPage from "../../pages/CommunicatorPage";
import EventUpdatePage from "../../pages/EventUpdatePage";
import SingleShipmentTrackingPage from '../../pages/SingleShipmentTrackingPage';
import SingleShipmentDetailsPage from "../../pages/SingleShipmentDetailsPage";
import ErrorPage from "../../pages/ErrorPage";
import CommunicatorViewCommentsPage from "../../pages/CommunicatorViewCommentsPage";
import CommunicatorCreateCommentPage from "../../pages/CommunicatorCreateCommentPage";
import PublicTrackingPage from "../../pages/PublicTrackingPage";
import GamePage from '../../pages/GamePage';
import EventCreatePage from "../../pages/EventCreatePage";
import TermsAndConditionsPage from "../../pages/TermsAndConditionsPage";

export const HOME_OVERVIEW_PAGE_PATH = "/";
export const AUTH_PAGE_PATH = "/auth";
export const SHIPMENT_TRACKING_PAGE_PATH = "/shipment-tracking";
export const SHIPMENT_DETAILS_PAGE_PATH = "/shipment-details";
export const COMMUNICATOR_PAGE_PATH = "/communicator";
export const COMMUNICATOR_CREATE_COMMENT_PAGE_PATH = "/communicator-create";
export const EVENT_UPDATE_PAGE_PATH = "/event-update";
export const TERMS_AND_CONDITIONS_PAGE_PATH = "/terms-and-conditions";
export const ERROR_PAGE_PATH = "/error/";
export const PUBLIC_TRACKING_PATH = "/";

function Navigator() {

    if (window.location.hostname.includes("public-tracking")) {
        return (
            <Routes>
                <Route path={PUBLIC_TRACKING_PATH} element={<PublicTrackingPage />} />
                <Route path="*" element={<ErrorPage />} />
            </Routes>
        );
    }

    return (
        <Routes>
            <Route path={HOME_OVERVIEW_PAGE_PATH} element={<OverviewPage />} />
            <Route path={AUTH_PAGE_PATH} element={<AuthPage />} />
            <Route path={SHIPMENT_TRACKING_PAGE_PATH} element={<ShipmentTrackingPage />} />
            <Route path={`${SHIPMENT_TRACKING_PAGE_PATH}/:uuid`} element={<SingleShipmentTrackingPage />} />
            <Route path={`${SHIPMENT_DETAILS_PAGE_PATH}/:uuid`} element={<SingleShipmentDetailsPage />} />
            <Route path={COMMUNICATOR_PAGE_PATH} element={<CommunicatorPage />} />
            <Route path={`${COMMUNICATOR_PAGE_PATH}/:uuid/:shipmentId`} element={<CommunicatorViewCommentsPage />} />
            <Route path={`${COMMUNICATOR_CREATE_COMMENT_PAGE_PATH}/:uuid/:shipmentId`}
                   element={<CommunicatorCreateCommentPage />} />
            <Route path={EVENT_UPDATE_PAGE_PATH} element={<EventUpdatePage />} />
            <Route path={`${EVENT_UPDATE_PAGE_PATH}/:uuid/:shipmentId`} element={<EventCreatePage />} />
            <Route path={TERMS_AND_CONDITIONS_PAGE_PATH} element={<TermsAndConditionsPage />} />
            <Route path="/fun/" element={<GamePage />} />
            <Route path={ERROR_PAGE_PATH} element={<ErrorPage />} />
            <Route path="*" element={<ErrorPage />} />
        </Routes>
    );
}

export default Navigator;

